import React from "react";
import { Award, Timer, Users, ShieldCheck } from "lucide-react";

const PILLARS = [
  {
    icon: Award,
    title: "Expertise métier",
    desc:
      "Étancheurs qualifiés, maîtrisant bitume, PVC, EPDM et résines techniques.",
  },
  {
    icon: Timer,
    title: "Réactivité 24h",
    desc:
      "Mobilisation rapide sur toute l'Île-de-France dès détection d'une infiltration.",
  },
  {
    icon: ShieldCheck,
    title: "Garantie décennale",
    desc:
      "Chaque intervention est couverte et documentée pour votre tranquillité.",
  },
  {
    icon: Users,
    title: "Interlocuteur unique",
    desc:
      "De l'audit à la réception du chantier, un chargé d'affaires dédié.",
  },
];

export default function Pourquoi() {
  return (
    <section
      id="pourquoi"
      data-testid="pourquoi-section"
      className="relative py-24 md:py-32 bg-[#F2F4F7]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-4">
          <span className="inline-block w-10 h-px bg-[#FF5A1F]" />
          <span className="label-kicker text-[#FF5A1F]">Pourquoi ETANCIA</span>
        </div>
        <h2
          data-testid="pourquoi-title"
          className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0F172A] leading-[1] max-w-3xl"
        >
          Le sérieux d'un bureau d'études. La vitesse d'un artisan.
        </h2>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t border-slate-200 bg-white">
          {PILLARS.map((p, i) => (
            <div
              key={i}
              data-testid={`pillar-${i}`}
              className="border-r border-b border-slate-200 p-7 lg:p-9"
            >
              <p.icon className="w-6 h-6 text-[#FF5A1F]" />
              <h3 className="mt-6 font-display font-bold text-xl text-[#0F172A]">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                {p.desc}
              </p>
              <div className="mt-8 font-display font-bold text-2xl text-slate-200">
                0{i + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
